__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/f6bf92f/_next/";